$(document).ready(function(){



        AOS.init({
          startEvent: 'DOMContentLoaded',
        });

  

  function SwymGrForLoop () {
    // if ($(document).find('.notACustomerLogin').length) {
    //   if ($(document).find('.ActiveHidden').length) {} else {
    //     console.log("Body Has A Class notACustomerLogin");
    //     $('product-form.itg_add_cart, .product-form__submit, .itg_add_cart .quick-add__submit').hide();
    //     $('product-form.itg_add_cart, .product-form__submit, .itg_add_cart .quick-add__submit').addClass('ActiveHidden');
    //   }
    // }

    
if ($(document).find('.notACustomerLogin').length) {
          $('product-form.itg_add_cart, .product-form__submit, .itg_add_cart .quick-add__submit').each(function() {
             if ($(this).hasClass('.ActiveHidden').length) {} else {
                $(this).hide();
                $(this).addClass('ActiveHidden');
             }
          });
      }


    

      if ($(document).find('.aB2BCustomerLogin').length) {
          $('.rfq-collection-btn, .product-form__buttons .rfq-btn, .rfq-btn').each(function() {
             if ($(this).hasClass('.ActiveHidden').length) {} else {
                $(this).hide();
                $(this).addClass('ActiveHidden');
             }
          });
      }


  
    
  }
  var interval = self.setInterval(function(){SwymGrForLoop()},50);






  
  $('.navPages-action-menu').click(function(event){
     event.preventDefault();
    $(this).closest('.navPages-item').find('.sub_coll_icon').toggleClass('is-open-icon');
    $(this).closest('.navPages-item').find('.navPage-subMenu.navPage-subMenu--vertical').toggleClass('is-open'); 
     $(this).closest('.navPages-item').toggleClass('navlink_active');
    $(this).closest('.navPages-item').find('.navPage-subMenu.navPage-subMenu--vertical').parent('.navPages-item ').siblings().find('.navPage-subMenu.navPage-subMenu--vertical').removeClass('is-open');
    $(this).closest('.navPages-item').siblings().removeClass('navlink_active');
  });
  $('.navPage-subMenu-menu').click(function(event){
     event.preventDefault();
    $(this).find('.navPage-childList').toggleClass('child-is-open');
    $(this).find('.submenu_coll_icon').toggleClass('submenu-is-open-icon');
  });
  $('.sbctn-drawer-button').click(function(){
    $('.sub_colletion_menu ').toggleClass('sbtn-drawer-content');
    $('subcollections_drawer').toggle();
    $('.filter_drawer_icon').toggle();
    $('.filter_close_icon').toggle();
  });

$('.SwymNav-SubItem>div>summary.header__menu-item span, .navPages-list li.navPages-item a.navPages-action span').on('click', function(event){
// $(this).attr('data-href');
window.location.href = $(this).attr('data-href');
});

$('.menu-drawer__menu .menu-drawer__menu summary.menu-drawer__menu-item span').on('click', function(event){
// $(this).attr('data-href');
window.location.href = $(this).attr('data-href');
});
  

  
    if($('html.itg-collection').length){
  if($('.sub_colletion_main li.collection-list__item.grid__item.list_item_clt').length){
    $('facet-filters-form.facets.facets-vertical-sort').css('opacity', '0');
    $('.mobile-facets__sort').css('opacity', '0');
    $('.product-count__text').css('opacity', '0');
     $('.mobile-facets__count').css('opacity', '0');
  }
}

    $('.product_desc_main .product_desc-heading').on('click', function(){
      $(this).parent().find('.product_desc_body').slideToggle();
      $(this).parent().siblings().find('.product_desc_body').slideUp();
      $(this).toggleClass('product_description_toggle');
      $(this).parent().siblings().find('.product_desc-heading').removeClass('product_description_toggle');
    });


  var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

    

  

   $('.itg_specs_submittals_accordian .itg_specs_head').on('click', function(){
      $(this).parent().find('.itg_submittals_main').slideToggle();
      $(this).toggleClass('itg_accordian_open');
      $(this).parent().parent().parent('.itg_submittals-section').siblings().find('.itg_submittals_main').slideUp();
     $(this).parent().parent().parent('.itg_submittals-section').siblings().find('.itg_specs_head').removeClass('itg_accordian_open');
    });

  

  


  $('[data-fancybox="gallery"]').fancybox({
    // Options will go here
    buttons : [
      'close'
    ],
    wheel : false,
    transitionEffect: "slide",
    thumbs          : false,
    hash            : false,
    loop            : false,
    // keyboard        : false,
    toolbar         : false,
    // animationEffect : false,
    arrows          : false,
    clickContent    : false,
    touch: false,
    showCloseButton: false
  });



   $.ajax({
      type: 'get',
      url: '/pages/sport-pride-1',
      dataType: 'html',
      success: function(data) {
          var getData = $(data).find('.sportpride-section').html();
              $(".itg-sport-pride #MainContent").append(getData);   
      
        
      }
    });


      $(document).on('click', '.sportpride-accordian .mascot_head', function(){
    $(this).parent().find('.mascot-images').slideToggle();
    $(this).toggleClass('itg_accordian_open');
    // $(this).parent('.mascot-row').siblings().find('.mascot-images').slideUp();
    // $(this).parent('.mascot-row').siblings().find('.mascot_head').removeClass('itg_accordian_open');
    $(this).parents().siblings().find('.mascot-images').slideUp();
    $(this).parents().siblings().find('.mascot_head').removeClass('itg_accordian_open');
  });

  $(document).ready(function(){

    if ($("body").hasClass("custom-dealer-locator")) {
    $(document).bind('keypress',  function(event){
     if(event.which === 13) { 
          //dealer-input-state  
         var thiss = $('.dealer-input-state .dealer-input-btn button')
         var stateVal = thiss.parent('.dealer-input-btn').find('#state-input').val().toLowerCase().replaceAll('&', '').replaceAll("'", "").replaceAll(',', '').replaceAll('.', '-').replace(/ /g,'-');
         if(stateVal === undefined || stateVal === null || stateVal === ''  ){}else{
            event.preventDefault();
           stateVal = stateVal.replaceAll('--', '-'); 
           var stateurl = (window.location.href).split('?')[0];
           window.location.replace(stateurl + '?state=' + stateVal);
         }
          
         //dealer-input-city
         var thisss = $('.dealer-input-city .dealer-input-btn button')
         var cityVal = thisss.parent('.dealer-input-btn').find('#city-input').val().toLowerCase().replaceAll('&', '').replaceAll("'", "").replaceAll(',', '').replaceAll('.', '-').replace(/ /g,'-');
         if(cityVal === undefined || cityVal === null || cityVal === ''  ){}else{
            event.preventDefault();
           cityVal = cityVal.replaceAll('--', '-');
           var cityurl = (window.location.href).split('?')[0];
           window.location.replace(cityurl + '?city=' + cityVal);
         }
          
         //dealer-input-dealer
         var thissss = $('.dealer-input-dealer .dealer-input-btn button')
         var dealerVal = thissss.parent('.dealer-input-btn').find('#dealer-input').val().toLowerCase().replaceAll('&', '').replaceAll("'", "").replaceAll(',', '').replaceAll('.', '').replace(/ /g,'-');
         if(dealerVal === undefined || dealerVal === null || dealerVal === ''  ){}else{
            event.preventDefault();
           var dealerVal = dealerVal.replaceAll('--', '-');
           var dealerurl = (window.location.href).split('?')[0];
           window.location.replace(dealerurl + '?dealer=' + dealerVal);
         }
          
         //dealer-input-zipcode 
           var thisssss = $('.dealer-input-zipcode .dealer-input-btn button')
           var zipcodeVal = thisssss.parent('.dealer-input-btn').find('#zipcode-input').val();
           if(zipcodeVal === undefined || zipcodeVal === null || zipcodeVal === ''  ){}else{
              event.preventDefault();
             zipcodeVal = zipcodeVal.replaceAll('--', '-');
             var zipcodeurl = (window.location.href).split('?')[0];
             window.location.replace(zipcodeurl + '?zip=' + zipcodeVal);
         }
     } 
     });
    
    }




    
    $(document).on('click', '.dealer-input-state .dealer-input-btn button', function(e){
      e.preventDefault();
 //     var stateVal = $(this).parent('.dealer-input-btn').find('input').val().replaceAll(' ', '-').replaceAll("'", "").replaceAll('&', '').toLowerCase();
       var stateVal = $(this).parent('.dealer-input-btn').find('input').val().toLowerCase().replaceAll('&', '').replaceAll("'", "").replaceAll(',', '').replaceAll('.', '-').replace(/ /g,'-');
      stateVal = stateVal.replaceAll('--', '-');
      console.log(stateVal);
      var stateurl = (window.location.href).split('?')[0];
      // var stateUrlmain = stateurl.split('?')[0];
      console.log(stateurl);
      // var stateName = '?state';
      // console.log(stateName);
      window.location.replace(stateurl + '?state=' + stateVal);
    });

    $(document).on('click', '.dealer-input-city .dealer-input-btn button', function(e){
      e.preventDefault();
     // var cityVal = $(this).parent('.dealer-input-btn').find('input').val().replaceAll(' ', '-').replaceAll("'", "").replaceAll('&-', '').toLowerCase();
      var cityVal = $(this).parent('.dealer-input-btn').find('input').val().toLowerCase().replaceAll('&', '').replaceAll("'", "").replaceAll(',', '').replaceAll('.', '-').replace(/ /g,'-');
      cityVal = cityVal.replaceAll('--', '-');
      console.log(cityVal);
      var cityurl = (window.location.href).split('?')[0];
      // var stateUrlmain = stateurl.split('?')[0];
      console.log(cityurl);
      // var stateName = '?state';
      // console.log(stateName);
      window.location.replace(cityurl + '?city=' + cityVal);
    });

    $(document).on('click', '.dealer-input-dealer .dealer-input-btn button', function(e){
      e.preventDefault();
   //   var dealerVal = $(this).parent('.dealer-input-btn').find('input').val().replaceAll(' ', '-').replaceAll("'", "").replaceAll('&', '').toLowerCase();
      var dealerVal = $(this).parent('.dealer-input-btn').find('input').val().toLowerCase().replaceAll('&', '').replaceAll("'", "").replaceAll(',', '').replaceAll('.', '').replace(/ /g,'-');
      var dealerVal = dealerVal.replaceAll('--', '-');
      console.log(dealerVal);
      var dealerurl = (window.location.href).split('?')[0];
      // var stateUrlmain = stateurl.split('?')[0];
      console.log(dealerurl);
      // var stateName = '?state';
      // console.log(stateName);
      window.location.replace(dealerurl + '?dealer=' + dealerVal);
    });

    $(document).on('click', '.dealer-input-zipcode .dealer-input-btn button', function(e){
      e.preventDefault();
     // var cityVal = $(this).parent('.dealer-input-btn').find('input').val().replaceAll(' ', '-').replaceAll("'", "").replaceAll('&-', '').toLowerCase();
      var zipcodeVal = $(this).parent('.dealer-input-btn').find('input').val();
      zipcodeVal = zipcodeVal.replaceAll('--', '-');
      console.log(zipcodeVal);
      var zipcodeurl = (window.location.href).split('?')[0];
      // var stateUrlmain = stateurl.split('?')[0];
      console.log(zipcodeurl);
      // var stateName = '?state';
      // console.log(stateName);
      window.location.replace(zipcodeurl + '?zip=' + zipcodeVal);
    });

});


  if(window.location.href.indexOf('?state=')!= -1){
    console.log('state');
      var stateHref = (window.location.href).split('=')[1];
    if(stateHref === null || stateHref === undefined || stateHref === ''){}else{
    $('body').addClass('locate-by-state');
    
    $('.dealer-locator-main .state-wrapper .state-row').each(function(){
      var stateAttr = $(this).attr('data-state');
      // console.log(stateAttr);
      if(stateAttr.indexOf(stateHref)!= -1){
        // console.log('stateAttr');
        $(this).show();
      }else{
        $(this).hide();
      }
    });
    }
  }

  if(window.location.href.indexOf('?city=')!= -1){
    console.log('city');    
    var cityHref = (window.location.href).split('=')[1];
    if(cityHref === null || cityHref === undefined || cityHref === ''){}else{
    $('body').addClass('locate-by-city');
    $('.dealer-locator-main .state-wrapper .state-row .state-dealer-details').each(function(){
      var cityAttr = $(this).attr('data-city');
      
      // console.log(stateAttr);
      if(cityAttr.indexOf(cityHref)!= -1){
        // console.log('stateAttr');
        $(this).parents('.state-row').addClass('active');
        $(this).addClass('sub-active');
      }
    });
    }
  }

  if(window.location.href.indexOf('?dealer=')!= -1){
    console.log('dealer');
    
    var dealerHref = (window.location.href).split('=')[1];
    console.log(dealerHref);
    if(dealerHref === null || dealerHref === undefined || dealerHref === ''){}else{
      $('body').addClass('locate-by-dealername');
      $('.dealer-locator-main .state-wrapper .state-row .state-dealer-details').each(function(){
        var dealerAttr = $(this).attr('data-dealer');
        console.log(dealerAttr);
        // console.log(stateAttr);
        if(dealerAttr.indexOf(dealerHref)!= -1){
          console.log('stateAttr');
          $(this).parents('.state-row').addClass('active');
          $(this).addClass('sub-active');
        }
      });
    }
  }


  if(window.location.href.indexOf('?zip=')!= -1){
    console.log('zip');    
    var zipcodeHref = (window.location.href).split('=')[1];
    if(zipcodeHref === null || zipcodeHref === undefined || zipcodeHref === ''){}else{
    $('body').addClass('locate-by-zipcode');
    $('.dealer-locator-main .state-wrapper .state-row .state-dealer-details').each(function(){
      var zipcodeAttr = $(this).attr('data-zipcode');
      
      // console.log(stateAttr);
      if(zipcodeAttr.indexOf(zipcodeHref)!= -1){
        // console.log('stateAttr');
        $(this).parents('.state-row').addClass('active');
          $(this).addClass('sub-active');
      }
    });
    }
  }

  });


// $('.dealer-locator-main .state-wrapper .state-row').each(function(){
//   var dealerAttr = $(this).find('.state-dealer-details').attr('data-dealer');
//   var dealerHref = (window.location.href).split('?dealer=')[1];
//   var cityAttr = $(this).find('.state-dealer-details').attr('data-city');
//   var cityHref = (window.location.href).split('?city=')[1];
//   var stateAttr = $(this).attr('data-state');
//   var stateHref = (window.location.href).split('?state=')[1];
//   if(dealerAttr.indexOf(dealerHref)!= -1){
//     $(this).show();
//   }else if(stateAttr.indexOf(stateHref)!= -1){
//     $(this).show();
//   }else if(cityAttr.indexOf(cityHref)!= -1){
//     $(this).show();
//   }else{
//     $(this).hide();
//   }
// });
  


$(document).ready(function(){
  $(document).on('click', '.header__inline-menu .list-menu.list-menu--inline li summary.header__menu-item:not(.link--text)', function(){
    // alert('Success');
    $(this).parents('li').find('ul.SwymNav-SubItemsMain, .SwymNav-SubItemsMain-ImgMain').toggleClass('itg_click_menu');
    $(this).toggleClass('menu_underline');
    // $('li.SwymNav-SubItem:first-child').find('.SwymNav-GrndItemsMain').addClass('itg_click_submenu');
    $(this).parents('li').siblings().find('ul.SwymNav-SubItemsMain, .SwymNav-SubItemsMain-ImgMain').removeClass('itg_click_menu');
    $(this).parents('li').siblings().find('summary.header__menu-item').removeClass('menu_underline');
    $('.SwymNav-GrndItemsMain').removeClass('itg_click_submenu');
  });
  
  // $(document).on('click', '.SwymNav-SubItemsMain li.SwymNav-SubItem summary svg.icon-caret', function(){
  //   $(this).parents('li.SwymNav-SubItem').find('.SwymNav-GrndItemsMain').addClass('itg_click_submenu');
  //   $(this).parents('li.SwymNav-SubItem').siblings().find('.SwymNav-GrndItemsMain').removeClass('itg_click_submenu');
  // });
$(document).ready(function(){
    $(document).on('mouseenter', '.SwymNav-SubItemsMain li.SwymNav-SubItem summary', function(){
        $(this).parents('li.SwymNav-SubItem').find('.SwymNav-GrndItemsMain').addClass('itg_click_submenu');
        $(this).parents('li.SwymNav-SubItem').siblings().find('.SwymNav-GrndItemsMain').removeClass('itg_click_submenu');
    });
});

  
  // $(document).on('click', '#map_holder #map_inner path, #map_holder #map_inner rect, #map .itg-additional-states .btn.button', function() {
  //   var getValueState = $(this).attr('class');
  //   $('.state-row[data-state]').each(function() {
  //     var getStateElement = $(this).attr('data-state');
  //     if(getValueState.indexOf(getStateElement)!= -1) {
  //       //$(this).attr('data-state');
  //       console.log($(this).attr('data-state'));
  //      // alert($(this).attr('data-state'));
  //         var $container = $("html,body");
  //         var $scrollTo = $(this);
  //         $container.animate({scrollTop: $scrollTo.offset().top - $container.offset().top },300); 
  //     }
  //   });
  // });

    $(document).on('click', '#map_holder #map_inner path, #map_holder #map_inner rect', function() {
    var getValueState = $(this).attr('class');
        $('.state-row[data-state]').each(function() {
          var getStateElement = $(this).attr('data-state');
          var  myArraysss = getValueState.split(" ");
           // console.log(getStateElement+' == '+myArraysss[0]);
              if(getStateElement == myArraysss[0]) {
                  var $container = $("html,body");
                   var $scrollTo = $(this);
                   $container.animate({scrollTop: $scrollTo.offset().top - $container.offset().top },300); 
              }else{
                // console.log('NOO');
              }
        });
  });

        $(document).on('click', '#map .itg-additional-states .btn.button', function() {
        var getValueState = $(this).attr('class');
          console.log(getValueState);
              $('.state-row[data-state]').each(function() {
                var getStateElement = $(this).attr('data-state');
                var  myArraysss = getValueState.split(" ");
                 // console.log(getStateElement+' == '+myArraysss[0]);
                    if(getStateElement == myArraysss[2]) {
                        var $container = $("html,body");
                         var $scrollTo = $(this);
                         $container.animate({scrollTop: $scrollTo.offset().top - $container.offset().top },300); 
                    }else{
                       console.log('NOO');
                    }
              });
        });


  


});

    
  





    

$(window).on('load', function(){
  if($('html.itg-collection').length){
  if($('.sub_colletion_main li.collection-list__item.grid__item.list_item_clt').length){
    $('facet-filters-form.facets.facets-vertical-sort').css('opacity', '0');
     $('.mobile-facets__sort').css('opacity', '0');
    $('.product-count__text').css('opacity', '0');
     $('.mobile-facets__count').css('opacity', '0');
  }
}

  
    AOS.refresh();

  
});



    $(window).on('load', function(){
      $('.SwymNav-SubItemsMain-ImgMain .SwymNav-SubItem .SwymNav-GrndItemsMain, .hasDropDown .SwymNav-Item .SwymNav-SubItemsMain').css('display', 'block');
      $('.SwymNav-ItemsMain .SwymNav-SubItemsMain-ImgMain').css('display', 'flex');
    });



       $(document).ready(function(){
$('.custom_banner').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  // autoplay: true,
  // autoplaySpeed: 5000,
  speed: 500
});


$(document).on('contextmenu', 'img, .card-wrapper, .product__modal-opener, .thumbnail', function(e){
  return false; 
});

  //  async function copyPicture(this_) { 
  //  try {             
  //   var imageCopy = $(this_).attr('src');
  //   console.log(imageCopy);
  //   const response = await fetch(imageCopy);
  //   const blob = await response.blob();
  //   await navigator.clipboard.write([
  //     new ClipboardItem({
  //       [blob.type]: blob
  //     })
  //   ]);
  //   console.log('Image copied.');
  //    $(this_).parent().addClass('image_copied');     
  //    $(this_).parent().css('position', 'relative');
  // } catch (err) {
  //   console.error(err.name, err.message);
  // }
  //   };



  //    $(document).on('contextmenu', 'img, .card-wrapper, .product__modal-opener, .thumbnail', function(e){
  //      var this_ = this;
  //      setTimeout(function(){
  //        this_ = this_
  //      copyPicture(this_);
  //        setTimeout(function(){
  //        $(this_).parent().removeClass('image_copied');
  //        },3000);
  //       }, 1000);       
  //    }); 

          var dataWeight = $('.product-form__input .select .select__select').find(":selected").attr('data-weight');
         console.log(dataWeight);
         $('.hideAll.sku_barcode p span.weight').text(dataWeight);
            $(document).on('change', '.product-form__input .select .select__select', function(){
          dataWeight = $(this).find(":selected").attr('data-weight');
          console.log(dataWeight);
              $('.hideAll.sku_barcode p span.weight').text(dataWeight);
        });
         
});

$(document).on('contextmenu', 'img, .card-wrapper, .product__modal-opener, .thumbnail', function(e){
 // var this_ = this;
 // var copyText = $(this).attr('src');
 //  navigator.clipboard.writeText(copyText).then(() => {
 //  $(this).parent().css('position','relative');
 //  $(this).parent().addClass('image_copied');
 //  setTimeout(function(){
 //   $(this_).parent().removeClass('image_copied');
 //  },1000);
 //  });     
}); 

$(document).on('contextmenu', 'img, .card-wrapper, .product__modal-opener, .thumbnail', function(e) {
 var this_ = this;
 var copyText = $(this).attr('src');
  
  copyText = copyText.replace(/\?v=.*?$/g,'');
  console.log(copyText);

  let fn=getFileName(copyText);
  saveAs(copyText,fn);

  
  // navigator.clipboard.writeText(copyText).then(() => {
  $(this).parent().css('position','relative');
  $(this).parent().addClass('image_copied');
    setTimeout(function(){
     $(this_).parent().removeClass('image_copied');
    },2500);
  // });     
});

function getFileName(str){
  return str.substring(str.lastIndexOf('/')+1);
}



$(document).ready(function(){
  $(document).on('click', '.itg-contact .g-container button.action.submit', function(){
    setTimeout(function(){
      if($('.block-container .globo-form-control').hasClass('has-error')){
      }else{       
        $(document).find('head').append("<!-- Event snippet for Contact Submission conversion page --> <script>   gtag('event', 'conversion', {'send_to': 'AW-10838636445/-gA4CJL2yaYDEJ3vobAo'}); </script>");
      }
    }, 3000);
  });


   $(document).on('click', '.itg-free-scorebook .g-container button.action.submit', function(){
    console.log('yes');
    setTimeout(function(){
      if($('.block-container .globo-form-control').hasClass('has-error')){
      }else{       
        $(document).find('head').append("<!-- Event snippet for Scorebook Request Submit conversion page --> <script>   gtag('event', 'conversion', {'send_to': 'AW-10838636445/bUwvCMmulqYDEJ3vobAo'}); </script>");
      }
    }, 3000);
  });
});

         